import { RefundModel } from 'api-hooks/refund/refund';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import Text from 'components/elements/text';
import {
  CardSection,
  FullContainer,
  Row,
  SeparatorHorizontal,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import { useFieldArray, useFormContext } from 'react-hook-form';

import AddonsCruiseTable from './addons-cruise';
import GuestCruiseTable from './guest-cruise';
import InformationCruiseTable from './information-cruise';

interface Props {
  refund?: RefundModel;
}

export default function CruiseSaleSection(props: Props) {
  const { control } = useFormContext();
  const name = 'cruiseSales';
  const { fields } = useFieldArray({
    control,
    name,
    keyName: 'customId',
  });

  const { t } = useTranslation();

  if (fields.length === 0) {
    return null;
  }

  return (
    <>
      {fields.map((field, index) => {
        return (
          <React.Fragment key={field.customId}>
            <Separator gap={24} />
            <CardSection>
              <FullContainer>
                <Row>
                  <Text $style={{ flex: 1 }} variant="HeadingXSmall">
                    {t('ticketSales:cruise_detail')} {index + 1}
                  </Text>
                  <SeparatorHorizontal $margin={16} />
                  <Input
                    type="check-box"
                    name="cruiseSales.0.reminder"
                    label={t('ticketSales:set_reminder')}
                    noMargin
                    disabled
                  />
                </Row>
                <Separator gap={24} />
                <InformationCruiseTable />
                <GuestCruiseTable parentIndex={index} refund={props.refund} />
                <AddonsCruiseTable parentIndex={index} refund={props.refund} />
              </FullContainer>
            </CardSection>
          </React.Fragment>
        );
      })}
    </>
  );
}
